import Icon from '../components/Icon.vue'

Icon.register({
  'external-link-square-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM360 96H248C226.7 96 215.9 121.9 231.1 137L263 169 67.5 364.5C62.8 369.2 62.8 376.8 67.5 381.5L98.5 412.5C103.2 417.2 110.8 417.2 115.5 412.5L311 217 343 248.9C358.1 264 384 253.4 384 232V120C384 106.7 373.3 96 360 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/external-link-square-alt.js
// module id = 0CLM
// module chunks = 144